var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.savedSignatureOrInitials && _vm.savedSignatureOrInitials !== '')?_c('img',{staticClass:"signature-image-bounds",attrs:{"src":_vm.savedSignatureOrInitials,"alt":"Signature"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }